import { render, staticRenderFns } from "./ServiceView.vue?vue&type=template&id=a6d5ff14&scoped=true&"
import script from "./ServiceView.vue?vue&type=script&lang=js&"
export * from "./ServiceView.vue?vue&type=script&lang=js&"
import style0 from "./ServiceView.vue?vue&type=style&index=0&id=a6d5ff14&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6d5ff14",
  null
  
)

export default component.exports